import { createContext, ReactNode, useContext } from "react";

import { useFilterTravelVoucher } from "./filter-travel-voucher.hook";

const FilterTravelVoucherContext = createContext(
  {} as ReturnType<typeof useFilterTravelVoucher>
);
export function useFilterTravelVoucherContext() {
  return useContext(FilterTravelVoucherContext);
}

interface FilterTravelVoucherProviderProps {
  children: ReactNode;
}
export function FilterTravelVoucherProvider({
  children,
}: FilterTravelVoucherProviderProps) {
  return (
    <FilterTravelVoucherContext.Provider value={useFilterTravelVoucher()}>
      {children}
    </FilterTravelVoucherContext.Provider>
  );
}